'use client'
import { Skeleton } from '@/components/ui/skeleton'
import { useRecentProductsQuery } from '@/hooks/react-query/products/use-recent-products'
import { useMobileNav } from '@/hooks/zustands/use-mobile-nav'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'

export const RecentProducts = ({ setFalse }: { setFalse: () => void }) => {
  const { setIsOpen } = useMobileNav()

  const { recentProducts, isLoading, isError } = useRecentProductsQuery(4)

  if (isLoading) {
    return (
      <div className='grid auto-cols-[160px] grid-flow-col gap-4 overflow-x-auto md:auto-cols-fr md:grid-cols-3 lg:grid-cols-4'>
        {[...Array(4)].map((_, i) => (
          <div key={i} className='space-y-4'>
            <Skeleton className='aspect-[3/4] rounded-lg' />
            <Skeleton className='h-4 w-2/3' />
            <Skeleton className='h-4 w-1/2' />
          </div>
        ))}
      </div>
    )
  }

  if (!recentProducts || recentProducts?.length === 0 || isError) {
    return <div>Không có sản phẩm đã xem gần đây</div>
  }

  return (
    <div>
      <h3 className='mb-4 text-base font-medium'>Sản phẩm đã xem gần đây</h3>
      <div className='grid auto-cols-[160px] grid-flow-col gap-4 overflow-x-auto md:auto-cols-fr md:grid-cols-3 lg:grid-cols-4'>
        {recentProducts.map((product) => (
          <Link
            key={product.id}
            href={`/product/${product.seo_alias}`}
            onClick={() => {
              setFalse()
              setTimeout(() => {
                setIsOpen(false)
              }, 300)
            }}
            className='block space-y-2'
          >
            <div className='aspect-[3/4] overflow-hidden rounded-lg bg-gray-50'>
              <Image
                src={ImageHelper.getImageUrl(
                  product.default_thumbnail || '/placeholder.jpg'
                )}
                alt={product.display_name}
                className='h-full w-full object-cover'
                width={100}
                height={100}
              />
            </div>
            <p className='line-clamp-2 text-sm'>{product.display_name}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
